import { useRecoilValue } from "recoil";
import CBSearchAutocompleteController from "../controller/CBSearchAutocompleteController";
import { sapEnumState } from "../../../state/customerbaseState";
import { useFormContext } from "react-hook-form";
import { CustomerSearchFilters } from "../../../types";

const CBDigitalIdentityStatusSearchFilter = () => {

    const sapEnum = useRecoilValue(sapEnumState);
    const formContext = useFormContext<CustomerSearchFilters>();
    
    return (
        <CBSearchAutocompleteController 
            idField="digitalIdentityStatus"
            formName="digitalIdentityStatus"
            label="digitalIdentityStatus"
            translateLabel="sapEnum.digitalIdentityStatus"
            options={sapEnum.digitalIdentityStatus}
            onChange={(value) => formContext.setValue("digitalIdentityStatus", value? value.value : "")}
        />
    )

}

export default CBDigitalIdentityStatusSearchFilter;